import React from 'react';
import { Link } from 'gatsby';

const Logo = ({ src }) => <Link to='/'><img src={src} className="logo-image" alt="Site logo"/></Link>;

export default Logo;
